import React from "react";

const TypographyContext = React.createContext<{
  color?: string;
  grayTextColor?: string;
}>({});

export const useTypographyContext = () => React.useContext(TypographyContext);

export default TypographyContext;
